const Handlebars = require('handlebars');

class Cloudsearch {
  constructor() {
    this.current_page = 1;
    this.size = 20;
    this.word = decodeURIComponent(this.getAllUrlParams().q) || '';
    this.fq = '';
    this.openweb_header = {
      openweb: "request_ec2",
    }

    this.prod_hosts = ["ec2-34-240-232-153.eu-west-1.compute.amazonaws.com", "d1zx188tqaw0kd", "design.bbvaexperience.com", "revision-j95bw15y"];
    this.sandbox_hosts = ["edicion-kaghs10c", "revision-kaghs10c", "kaghs10c", "dev-design.bbvaexperience.com"];

    if (this.prod_hosts.includes(location.host)) {
      this.projectId = "j95bw15y";
      //this.url_cloudfront = this.prod_hosts[1] + '.cloudfront.net';
      this.url_cloudfront = this.prod_hosts[2];
      this.headers = null;
    } else if (this.sandbox_hosts.includes(location.host.replace('.openweb.bbva',''))) {
      this.projectId = "kaghs10c";
      this.url_cloudfront = this.sandbox_hosts[1] + '.openweb.bbva';
    }

    /**
     * viewable: number of elements to show in pagination. Must be an odd number
     * leap: factor to calculate the "middle" number to print. Depends on viewable value
     * 5 -> 3
     * 7 -> 4
     * 9 -> 5
     */
    this.pagination = {
      viewable: 5,
      leap: 3,
    };

    //Uncomment to make it work on production
    this.querySearch();

    //Sample code, delete if works
    //this.renderPagination( 0 );
  }

  querySearch() {
    if (document.querySelector('.component-search') != null) {
      document.querySelector("#q").innerText = '"' + this.word + '"';
      let loader_gif = '<img src="/wp-content/themes/ui/img/Spinner_White_128.gif" class="loading"/>';

      document.querySelector('.thumbnail-container').setAttribute("style", "justify-content: center")
      document.querySelector('.thumbnail-container').innerHTML = loader_gif;

      let search_data = {
        arr_return_vars: ["title", "resourcename", "description", "domain", "keywords", "image_src", "topic", "category", "date", "wp_text", "wp_double", "wp_text_array", "wp_double_array", "_score"],
        keyword: this.word,
        size: this.size,
        start: (this.current_page - 1) * this.size,
        options: "{fields:['title^5', 'topic^4', 'category^3', 'description^2']}",
        fq: this.fq,
        sort: '_score desc',
        parser: "lucene",
      };

      let search_options = {
        //mode: 'no-cors'
      };

      if (location.host.indexOf("edicion") != -1 || location.host.indexOf("ec2-34-240-232-153") != -1) {
        search_options.headers = this.openweb_header;
      }

      fetch(this.parseSearchUrl(search_data), search_options)
        .then(response => response.json())
        .then(result => {
          //console.log(result);
          let num_results = "0";
          if (result.data.hits != undefined) {
            document.querySelector("#count").innerText = result.data.hits.found;
            if (result.data.hits.found > 0) {
              if (!document.querySelector(".not-found").classList.contains('hide')) {
                document.querySelector(".not-found").classList.add('hide');
              }
              this.renderResults(result.data.hits.hit);
              this.renderPagination(result.data.hits.found);
              num_results = '' + result.data.hits.found;
            } else {
              document.querySelector(".not-found").classList.remove('hide');
              document.querySelector('.thumbnail-container').innerHTML = '';
            }
          }
          if( this.current_page === 1 ) {
            this.addTaggingInfo(this.word, this.word, num_results);
          } else {
            this.removeTaggingInfo();
          }
          window.digitalView('Page View', window.ExperienceTheme.analytics.getDigitalData());
          window.ExperienceTheme.analytics.addIfCookiesEnabled();
        })
        .catch(function (err) {
          console.log("Error on fetch", err);
        });
    }
  }

  parseSearchUrl(search_data) {
    let search_url = 'https://' + this.url_cloudfront + '/bbva-components/search?project=' + this.projectId;
    //let search_url = '/bbva-components/search?project=' + this.projectId;

    let full_search_url = search_url;

    if ('arr_return_vars' in search_data) {
      full_search_url += "&return=" + search_data.arr_return_vars.join();
    }
    if ('keyword' in search_data) {
      if (search_data.keyword.indexOf('"') > -1)
        full_search_url += '&q=' + search_data.keyword;
      else
        full_search_url += '&q=*' + search_data.keyword + '*';
    } else {
      full_search_url += "&q=**";
    }
    if ('size' in search_data) {
      full_search_url += "&size=" + search_data.size;
    }
    if ('start' in search_data) {
      full_search_url += "&start=" + search_data.start;
    }
    if ('options' in search_data) {
      full_search_url += "&q.options=" + search_data.options;
    }
    if ('fq' in search_data && search_data.fq != '') {
      full_search_url += "&fq=" + search_data.fq;
    }
    if ('sort' in search_data && search_data.sort != '') {
      full_search_url += "&sort=" + search_data.sort;
    }
    if ('parser' in search_data) {
      full_search_url += "&q.parser=" + search_data.parser;
    } else {
      full_search_url += "&q.parser=lucene";
    }
    //console.log(full_search_url);
    return full_search_url;
  }

  renderResults(items = []) {
    const result_tpl = `<a href="{{url}}" class="thumbnail" title="{{title_ref}}">
            <div class="thumbnail__img--lightGrey" style="background-image: url( {{featured_image}} ); background-repeat: no-repeat; background-position: center center; background-size: contain;"></div>
            <div class="thumbnail__thumbnailDesc">
                <p class="element-family">{{{category}}} - {{{family}}}</p>
                <span class="tag tag--updated">{{{platform}}}</span>
                <p class="body-copy-bold">{{{title}}}</p>
            </div>
        </a>`;
    var template = Handlebars.compile(result_tpl);

    let all_results = '';
    items.forEach(item => {
      let data = {
        url: item.fields.resourcename != undefined ? item.fields.resourcename : '',
        title: this.highlight(item.fields.title != undefined ? item.fields.title : ''),
        title_ref: item.fields.title != undefined ? item.fields.title : '',
        category: item.fields.category != undefined ? item.fields.category : '',
        platform: item.fields.topic != undefined ? item.fields.topic : '',
        family: this.highlight(item.fields.description != undefined ? item.fields.description : ''),
        featured_image: item.fields.image_src != undefined ? item.fields.image_src : '',
      };

      var result = template(data);
      all_results += result;
    });

    let container = document.querySelector('.thumbnail-container');
    container.removeAttribute("style");
    container.innerHTML = all_results;
  }

  highlight(resultText) {
    var re = new RegExp(this.word, "gi");
    return resultText.replace(re, '<b>$&</b>');
  }

  renderPagination(total = 0) {
    if (total == 0) {
      document.querySelector('.not-found').classList.remove('hide');
      return;
    } else {
      document.querySelector('.not-found').classList.add('hide');
    }

    let first = '<a class="symbol first ui-first" href="#" title="First"></a>';
    let prev = '<a class="symbol prev ui-back" href="#" title="Previous"></a>';
    let next = '<a class="symbol next ui-next" href="#" title="Next"></a>';
    let last = '<a class="symbol last ui-end" href="#" title="Last"></a>';

    this.num_pages = Math.ceil(total / this.size);

    /*if( this.current_page === this.num_pages && ! document.querySelector('.pagination').classList.contains('hide') ) {
        document.querySelector('.pagination').classList.add('hide');
        return;
    }*/

    let pagination_str = '';
    if (this.current_page < this.num_pages) {
      if (this.current_page > 1) {
        pagination_str += first + prev;
      }

      pagination_str += this.getPageItems(total);
      pagination_str += next + last;
    } else {
      pagination_str += first + prev;
      pagination_str += this.getPageItems(total);
    }

    document.querySelector('.pagination').classList.remove('hide');
    document.querySelector('.pagination').innerHTML = pagination_str;
    let page_numbers = document.querySelectorAll('.pagination .page-number');
    page_numbers[page_numbers.length - 1].classList.add('last-number');

    this.setupEvents();
  }

  getPageItems() {
    let page_item_tpl = Handlebars.compile(`<a class="pagination__number {{current}}" aria-current="page" href="#">{{number}}</a>`);
    let page_item_text_tpl = Handlebars.compile(`<p class="pagination__content {{mobileClass}}">{{ text }}</p>`);
    //let offset = this.current_page + this.pagination.viewable - 1;
    //let max_pages = this.pagination.viewable < max_pages ? this.pagination.viewable : max_pages;

    let prev_elements = '';
    let middle_element = page_item_tpl({
      current: 'pagination__number--current',
      number: this.current_page,
    });
    let next_elements = '';

    let prev_min_value = this.current_page - this.pagination.viewable + this.pagination.leap;
    let next_max_value = this.current_page + this.pagination.viewable - this.pagination.leap;

    if (next_max_value > this.num_pages) {
      if (next_max_value == this.num_pages + 1) {
        prev_min_value += 1;
      }
      prev_min_value -= this.pagination.viewable - this.pagination.leap;
    }
    for (let i = prev_min_value; i < this.current_page; i++) {
      if (i > 0) {
        prev_elements += page_item_tpl({
          current: '',
          number: i,
        });
      }
    }

    if (prev_min_value <= 0) {
      if (prev_min_value == 0) {
        next_max_value -= 1;
      }
      next_max_value += this.pagination.viewable - this.pagination.leap;
    }
    for (let j = this.current_page + 1; j <= next_max_value; j++) {
      if (j <= this.num_pages) {
        next_elements += page_item_tpl({
          current: '',
          number: j,
        });
      }
    }

    let preposition = document.querySelector('html').getAttribute('lang').split('-')[0] == 'es'?'de':'of';
    let mobileClass = '';
    if( prev_elements.length === 0 && next_elements.length > 0 ) {
      mobileClass = 'pagination__content--move-right';
    } else if( next_elements.length === 0 && prev_elements.length > 0 ) {
      mobileClass = 'pagination__content--move-left';
    }
    let page_text = `${this.current_page} ${preposition} ${this.num_pages}`;

    return prev_elements + middle_element + next_elements + page_item_text_tpl({text: page_text, mobileClass: mobileClass});
  }

  setupEvents() {
    /**
     * Filter Events
     */
    document.querySelectorAll('.dropdown__ui_platform .dropdown__menu .item, .dropdown__ui_category .dropdown__menu .item, .dropdown__ui_family .dropdown__menu .item').forEach(element => {
      element.addEventListener('mousedown', this.applyFilter.bind(this));
    });


    /**
     * Pagination Events
     */
    document.querySelectorAll('.page-number:not(.current)').forEach(element => {
      //element.removeEventListener('click', )
      element.addEventListener('click', this.queryPage.bind(this));
    });

    document.querySelectorAll('.symbol').forEach(element => {
      element.addEventListener('click', this.queryPage.bind(this));
    });
  }

  queryPage(event) {
    event.stopPropagation();
    event.preventDefault();
    let symbol_prefix = 'pagination__symbol--';

    if (event.currentTarget.classList.contains('pagination__number')) {
      this.current_page = ~~(event.currentTarget.innerHTML);
    } else if (event.currentTarget.classList.contains(symbol_prefix + 'first')) {
      this.current_page = 1;
    } else if (event.currentTarget.classList.contains(symbol_prefix + 'prev')) {
      this.current_page -= 1;
    } else if (event.currentTarget.classList.contains(symbol_prefix + 'next')) {
      this.current_page += 1;
    } else if (event.currentTarget.classList.contains(symbol_prefix + 'last')) {
      this.current_page = this.num_pages;
    }

    this.querySearch();
    //Sample code, delete if works
    //this.renderPagination( 30 );
  }

  applyFilter(event) {
    //reset current_page
    this.current_page = 1;
    let topic = "";
    let category = "";
    let description = "";
    let fq = "";

    if (event.path[2].classList.contains("dropdown__ui_platform") && event.currentTarget.dataset.dropdownValue != 0) {
      topic = "(and topic:'" + event.currentTarget.dataset.dropdownValue + "')";
    }

    if (event.path[2].classList.contains("dropdown__ui_category") && event.currentTarget.dataset.dropdownValue != 0) {
      category = "(and category:'" + event.currentTarget.dataset.dropdownValue + "')";
    }

    if (event.path[2].classList.contains("dropdown__ui_family") && event.currentTarget.dataset.dropdownValue != 0) {
      description = "(and description:'" + event.currentTarget.dataset.dropdownValue + "')";
    }

    if (topic != '') {
      fq += topic + " ";
    }

    if (category != '') {
      fq += category + " ";
    }

    if (description != '') {
      fq += description + " ";
    }

    if (fq != '') {
      this.fq = "(and " + fq + " )";
    }
    this.querySearch();
    //console.log("applying filter", event.currentTarget);
  }

  getAllUrlParams(url) {

    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    let searchParams = new URLSearchParams(queryString)
    for (let p of searchParams) {
      //console.log(p);
      obj[p[0]] = p[1];
    }
    return obj;

    // if query string exists
    /* if (queryString) {

      // stuff after # is not part of query string, so get rid of it
      queryString = queryString.split('#')[0];

      // split our query string into its component parts
      var arr = queryString.split('&');

      for (var i = 0; i < arr.length; i++) {
        // separate the keys and the values
        var a = arr[i].split('=');

        // set parameter name and value (use 'true' if empty)
        var paramName = a[0];
        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

        // (optional) keep case consistent
        paramName = paramName.toLowerCase();
        if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

        // if the paramName ends with square brackets, e.g. colors[] or colors[2]
        if (paramName.match(/\[(\d+)?\]$/)) {

          // create key if it doesn't exist
          var key = paramName.replace(/\[(\d+)?\]/, '');
          if (!obj[key]) obj[key] = [];

          // if it's an indexed array e.g. colors[2]
          if (paramName.match(/\[\d+\]$/)) {
            // get the index value and add the entry at the appropriate position
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            // otherwise add the value to the end of the array
            obj[key].push(paramValue);
          }
        } else {
          // we're dealing with a string
          if (!obj[paramName]) {
            // if it doesn't exist, create property
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === 'string') {
            // if property does exist and it's a string, convert it to an array
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            // otherwise add the property
            obj[paramName].push(paramValue);
          }
        }
      }
    }
    return obj; */
  }

  addTaggingInfo(searchTerm, searchEnterTerm, numResults) {
    window.ExperienceTheme.analytics.setSearchInfo(searchTerm, searchEnterTerm, numResults);
    //digitalView('Page View', digitalData);
  }

  removeTaggingInfo() {
    window.ExperienceTheme.analytics.setSearchInfo('', '');
  }
}

export default Cloudsearch
